import { styled } from "styled-components";

import { CrossIcon } from "common/components";

export const CompletedDownloadContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 1rem;
  padding: 10px;
`;

export const CloseButton = styled(CrossIcon)`
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.textFade};
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 20px;
  &:hover {
    color: ${({ theme }) => theme.colors.textBright};
  }
`;
